<div [formGroup]="driverInfoForm">
  <div class="stepper-container">
    <!--Driver ID-->
    <!-- Preloaded driver display (when driver is preloaded from Add New) -->
    <mat-form-field
      *ngIf="showPreloadedDriver"
      appearance="outline"
      class="custom-input disabled"
    >
      <mat-label>Driver ID*</mat-label>
      <span matPrefix>
        <div class="input-img">
          <mat-spinner
            *ngIf="isLoadingPreloadedDriver"
            mode="indeterminate"
            diameter="20"
            class="input-spinner"
          ></mat-spinner>
          <img
            *ngIf="!isLoadingPreloadedDriver"
            [src]="getImageUrl(preloadedDriverCode)"
            appImgFallback
            alt="Avatar"
            class="user-avatar"
          />
        </div>
      </span>
      <input
        type="text"
        matInput
        [value]="
          isLoadingPreloadedDriver ? 'Loading driver data...' : preloadedDriverDisplayText
        "
        readonly
        disabled
      />
    </mat-form-field>

    <!-- Normal driver search (when no preloaded driver) -->
    <app-driver-search
      *ngIf="showDriverSearch"
      label="Driver ID*"
      [organization]="selectedOrganization"
      [isEnabled]="isDriverSearchEnabled"
      [assignee]="assignee"
      (driverSelected)="handleDriverSelected($event)"
    ></app-driver-search>

    <div class="stepper-container driver">
      <h3>Driver Info</h3>
      <div class="row">
        <mat-label class="label">Driver Name</mat-label>
        <span class="driver-value">{{ driverInfoForm.get("driverName")?.value }}</span>
      </div>
      <div class="row">
        <mat-label class="label">Terminal</mat-label>
        <span class="driver-value">{{ driverInfoForm.get("terminal")?.value }}</span>
      </div>
      <div class="row">
        <mat-label class="label">Fleet Manager</mat-label>
        <span class="driver-value">{{ driverInfoForm.get("fleetManager")?.value }}</span>
      </div>
      <div class="row">
        <mat-label class="label">Safety Trainer</mat-label>
        <span class="driver-value">{{ driverInfoForm.get("safetyManager")?.value }}</span>
      </div>
    </div>
    <h3 class="contact">Contact Info</h3>
    <mat-form-field appearance="outline">
      <mat-label>Cell #</mat-label>
      <input matInput formControlName="cellphone" />
    </mat-form-field>
    <mat-error
      *ngIf="
        driverInfoForm.get('cellphone')?.hasError('required') &&
        driverInfoForm.get('cellphone')?.touched
      "
    >
      This field is required
    </mat-error>
    <mat-error
      *ngIf="
        driverInfoForm.get('cellphone')?.hasError('invalidPhone') &&
        !driverInfoForm.get('cellphone')?.hasError('required') &&
        driverInfoForm.get('cellphone')?.touched
      "
    >
      Invalid phone number
    </mat-error>
  </div>
</div>
